module.exports = __webpack_public_path__ + "img/ratings-bubble-tail-alt.a6d76f0.svg";